import { RouteObject, useRoutes } from "react-router-dom";
import { useWorksheetsFlag } from "rwb/pages/project/hooks/usePipelinesFlag";
import RoutePath from "rwb/pages/project/types/enums/routePath";
import RouterError from "~/components/RouterError";

/**
 * Helper to give each route in a list of sub-routes the same error boundary/fallback
 * @param routeDefinitions
 */
export const useSafeRoutes = (routeDefinitions: RouteObject[]) => {
  const isWorksheetsEnabled = useWorksheetsFlag();

  const filteredRoutes = routeDefinitions.filter(
    (route) => !route.path?.includes(RoutePath.WORKSHEETS) || isWorksheetsEnabled
  );

  return useRoutes(
    filteredRoutes.map((def) => ({
      ...def,
      // ID is necessary for useRouteError in RouterError
      id: def.path,
      errorElement: <RouterError />,
    }))
  );
};
